import { fetchDocumentUrl, fetchDocumentWebUrl } from "../../api/document/Documents";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* global localStorage, window */

export function openDocumentById(id: string) {
  fetchDocumentUrl(id).then((obj) => {
    openDocument(obj.url);
  });
}

export function openDocument(url: string) {
  // eslint-disable-next-line no-undef
  Word.run(async (context) => {
    context.application.openDocument(url);
  });
}

export function openFileExcel(id: string) {
  fetchDocumentWebUrl(id).then((obj) => {
    window.open(obj.url);
  });
}
